import { ChangeDetectorRef, Component, Input, OnInit, forwardRef } from '@angular/core';
import { ControlContainer, NgForm, NgModelGroup } from '@angular/forms';
import { ActivatedRoute } from '@angular/router';
import * as _ from 'lodash';
import { Atividade } from 'src/app/core/atividade';
import { Modulos } from 'src/app/core/modulos';
import { PlanosAcao } from 'src/app/core/planos-acao';
import { Projeto } from 'src/app/core/projeto';
import { Unidade } from 'src/app/core/unidade';
import { PlanosAcaoService } from 'src/app/services/planosAcao/planos-acao.service';
import { ProgramaService } from 'src/app/services/programa/programa.service';
import { ProjetoService } from 'src/app/services/projeto/projeto.service';
import { UnidadeService } from 'src/app/services/unidade/unidade.service';
import { Acesso } from '../../../../core/acesso';
import { Objetivo } from '../../../../core/objetivo';
import { ObjetivoAtividade } from '../../../../core/objetivo-atividade';
import { DataUtilService } from '../../../../services/commons/data-util.service';
import { Programa } from './../../../../core/programa';

@Component({
  selector: 'dados-atividade',
  templateUrl: './dados-atividade.component.html',
  styleUrls: ['./dados-atividade.component.css'],
  viewProviders: [
                  { provide: ControlContainer, useExisting: NgForm },
                  { provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup) }
                 ]
})
export class DadosAtividadeComponent implements OnInit {
  public mascaraHorario = [/\d/, /\d/, ':', /[0-5]/, /\d/];


  @Input() atividade: Atividade;
  @Input() perfilAcesso: Acesso;

  listaPlanosAcao: PlanosAcao[];
  projetos: Projeto[];
  programas: Programa[];
  unidades: Unidade[];

  tipoHorario: any = [
    { id: 'F', descricao: 'FIXO' },
    { id: 'L', descricao: 'LIVRE' },
  ];

  localExecucao: any = [
    { id: 'I', descricao: 'INTERNA' },
    { id: 'E', descricao: 'EXTERNA' },
  ];

  mostrarCampos = false;
  campoDesabilitado = false;

  constructor(
    private planosAcaoService: PlanosAcaoService,
    private projetoService: ProjetoService,
    private programaService: ProgramaService,
    private unidadeService: UnidadeService,
    private activatedRoute: ActivatedRoute,
    private dataUtilService: DataUtilService,
    protected drc: ChangeDetectorRef
  ) { }

  ngAfterContentChecked(): void {
    this.drc.detectChanges();
  }

  ngOnInit() {
    this.mostrarCampos = false;

    this.unidadeService.getAllUnidadesUsuarioLogadoTemAcesso().subscribe((unidades: Unidade[]) => {
      this.unidades = unidades;
    });

    if ( this.activatedRoute.snapshot.data.modulo === Modulos.ATIVIDADE_PEDAGOGICO) {
      this.mostrarCampos = true;

      this.planosAcaoService.getAll().subscribe((planosAcao: PlanosAcao[]) => {
        this.listaPlanosAcao = planosAcao;
      });

      this.projetoService.getAllIntituicaoLogada().subscribe((projetos: Projeto[]) => {
        this.projetos = projetos;
      });

      this.programaService.getAllCombo().subscribe((programas: Programa[]) => {
        this.programas = programas;
      });
    }

  }


  hasDiaSemana(): boolean {
    return !this.atividade.segunda
        && !this.atividade.terca  
        && !this.atividade.quarta 
        && !this.atividade.quinta 
        && !this.atividade.sexta  
        && !this.atividade.sabado 
        && !this.atividade.domingo;
  }


  carregarUnidade() {
    if (this.atividade.unidade && this.atividade.unidade.idUnidade) {
      this.atividade.unidade = _.cloneDeep(_.find(this.unidades,  (f: Unidade) => f.idUnidade === this.atividade.unidade.idUnidade));
    }
  }

  addObjetivoAtividade() {
    if (!this.atividade.objetivosAtividade)
      this.atividade.objetivosAtividade = [];

    const objetivoAtividade: ObjetivoAtividade = new ObjetivoAtividade();
    objetivoAtividade.id = undefined;
    objetivoAtividade.objetivo = new Objetivo();
    this.atividade.objetivosAtividade.push(objetivoAtividade);
  }

  onValorChangePercurso(registro: any) {
    this.atividade.percurso = registro;
  }

  onTimeChange(value: string) {
    if (!value) {
      this.atividade.cargaHoraria = null;
      return;
    }
  
    const [hh, mm] = value.split(':').map(Number);
  
    if (!isNaN(hh) && !isNaN(mm) && mm >= 0 && mm < 60) {
      this.atividade.cargaHoraria = hh + mm / 60;
    }
  }

  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }
  
}
